"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const class_transformer_1 = require("class-transformer");
const re = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24\:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
function TransformIso8601Date(defaultValue) {
  const toPlain = (0, class_transformer_1.Transform)(obj => {
    const value = obj.value;
    if (value instanceof Date) {
      return value.toISOString();
    } else {
      if (typeof defaultValue === "function") {
        return defaultValue(value);
      }
      return defaultValue;
    }
  }, {
    toPlainOnly: true
  });
  const toClass = (0, class_transformer_1.Transform)(obj => {
    const value = obj.value;
    if (typeof value === "string" && re.test(value)) {
      return new Date(value);
    } else if (value instanceof Date) {
      return value;
    }
    return value;
  }, {
    toClassOnly: true
  });
  return function (target, key) {
    toPlain(target, key);
    toClass(target, key);
  };
}
exports.default = TransformIso8601Date;
